import PlanProgressDataStore from '../../datastores/PlanProgressDataStore';

export default class PlanProgressDataStoreMock
  implements PlanProgressDataStore
{
  getPlanProgressDetail() {
    return {
      isProcessing: false,
      items: [
        {
          status: 'CONVALIDADO',
          term: '00',
          name: 'NIVELACIÓN DE REDACCIÓN',
          courseId: '018414',
          code: '100000X106',
          credits: '4.00',
          type: 'O',
          hours: '4.00',
          prerequisites: null
        },
        {
          status: 'CONVALIDADO',
          term: '00',
          name: 'NIVELACIÓN DE MATEMÁTICA-HUMANIDADES',
          courseId: '019369',
          code: '100000X105',
          credits: '4.00',
          type: 'O',
          hours: '4.00',
          prerequisites: null
        },
        {
          status: 'APROBADO',
          term: '01',
          name: 'INDIVIDUO Y MEDIO AMBIENTE',
          courseId: '013797',
          code: '100000N09I',
          credits: '2.00',
          type: 'O',
          hours: '2.00',
          prerequisites: [
            {
              code: '100000X106',
              name: 'NIVELACIÓN DE REDACCIÓN'
            }
          ]
        },
        {
          status: 'APROBADO',
          term: '01',
          name: 'INGLÉS I',
          courseId: '013785',
          code: '100000N03I',
          credits: '3.00',
          type: 'O',
          hours: '3.00',
          prerequisites: null
        },
        {
          status: 'APROBADO',
          term: '01',
          name: 'INTRODUCCIÓN A LA PSICOLOGÍA',
          courseId: '018053',
          code: '100000P22S',
          credits: '4.00',
          type: 'O',
          hours: '4.00',
          prerequisites: null
        },
        {
          status: 'CONVALIDADO',
          term: '01',
          name: 'INTRODUCCIÓN A LA VIDA UNIVERSITARIA (IVU)',
          courseId: '021027',
          code: '100000VU04',
          credits: '3.00',
          type: 'O',
          hours: '3.00',
          prerequisites: null
        },
        {
          status: 'CONVALIDADO',
          term: '01',
          name: 'OBSERVACIÓN DEL COMPORTAMIENTO',
          courseId: '018410',
          code: '100000P03S',
          credits: '3.00',
          type: 'O',
          hours: '3.00',
          prerequisites: null
        },
        {
          status: 'APROBADO',
          term: '01',
          name: 'COMPRENSIÓN Y REDACCIÓN DE TEXTOS I',
          courseId: '018674',
          code: '100000AL01',
          credits: '4.00',
          type: 'O',
          hours: '4.00',
          prerequisites: [
            {
              code: '100000X106',
              name: 'NIVELACIÓN DE REDACCIÓN'
            }
          ]
        },
        {
          status: 'APROBADO',
          term: '02',
          name: 'BASES BIOLÓGICAS DEL COMPORTAMIENTO',
          courseId: '018546',
          code: '100000P12S',
          credits: '4.00',
          type: 'O',
          hours: '4.00',
          prerequisites: [
            {
              code: '100000VU04',
              name: 'INTRODUCCIÓN A LA VIDA UNIVERSITARIA (IVU)'
            }
          ]
        },
        {
          status: 'APROBADO',
          term: '02',
          name: 'INGLÉS II',
          courseId: '013790',
          code: '100000N05I',
          credits: '3.00',
          type: 'O',
          hours: '3.00',
          prerequisites: [
            {
              code: '100000N03I',
              name: 'INGLÉS I'
            }
          ]
        },
        {
          status: 'APROBADO',
          term: '02',
          name: 'OBSERVACIÓN Y ENTREVISTA',
          courseId: '018547',
          code: '100000P13S',
          credits: '4.00',
          type: 'O',
          hours: '4.00',
          prerequisites: [
            {
              code: '100000P03S',
              name: 'OBSERVACIÓN DEL COMPORTAMIENTO'
            }
          ]
        },
        {
          status: 'APROBADO',
          term: '02',
          name: 'PSICOLOGÍA DEL DESARROLLO I: APRENDIZAJE DE SERVICIO',
          courseId: '008868',
          code: '100000PS27',
          credits: '4.00',
          type: 'O',
          hours: '5.00',
          prerequisites: null
        },
        {
          status: 'APROBADO',
          term: '02',
          name: 'TECNOLOGÍAS DEL APRENDIZAJE',
          courseId: '018449',
          code: '100000P11S',
          credits: '2.00',
          type: 'O',
          hours: '3.00',
          prerequisites: null
        },
        {
          status: 'APROBADO',
          term: '02',
          name: 'TECNOLOGÍAS DEL APRENDIZAJE',
          courseId: '018756',
          code: '100000P11V',
          credits: '2.00',
          type: 'O',
          hours: '3.00',
          prerequisites: null
        },
        {
          status: 'APROBADO',
          term: '02',
          name: 'COMPRENSIÓN Y REDACCIÓN DE TEXTOS II',
          courseId: '018693',
          code: '100000A16E',
          credits: '4.00',
          type: 'O',
          hours: '4.00',
          prerequisites: [
            {
              code: '100000AL01',
              name: 'COMPRENSIÓN Y REDACCIÓN DE TEXTOS I'
            }
          ]
        },
        {
          status: 'APROBADO',
          term: '03',
          name: 'INGLÉS III',
          courseId: '013795',
          code: '100000N08I',
          credits: '3.00',
          type: 'O',
          hours: '3.00',
          prerequisites: [
            {
              code: '100000N05I',
              name: 'INGLÉS II'
            }
          ]
        },
        {
          status: 'APROBADO',
          term: '03',
          name: 'NEUROPSICOLOGÍA',
          courseId: '008874',
          code: '100000PS29',
          credits: '4.00',
          type: 'O',
          hours: '4.00',
          prerequisites: [
            {
              code: '100000P03S',
              name: 'OBSERVACIÓN DEL COMPORTAMIENTO'
            }
          ]
        },
        {
          status: 'APROBADO',
          term: '03',
          name: 'PERSONALIDAD',
          courseId: '008878',
          code: '100000PS30',
          credits: '3.00',
          type: 'O',
          hours: '4.00',
          prerequisites: [
            {
              code: '100000P13S',
              name: 'OBSERVACIÓN Y ENTREVISTA'
            }
          ]
        },
        {
          status: 'APROBADO',
          term: '03',
          name: 'PROBLEMAS Y DESAFÍOS EN EL PERÚ ACTUAL',
          courseId: '100000',
          code: '100000A21L',
          credits: '3.00',
          type: 'O',
          hours: '3.00',
          prerequisites: [
            {
              code: '100000N09I',
              name: 'INDIVIDUO Y MEDIO AMBIENTE'
            },
            {
              code: '100000AL01',
              name: 'COMPRENSIÓN Y REDACCIÓN DE TEXTOS I'
            }
          ]
        },
        {
          status: 'APROBADO',
          term: '03',
          name: 'PSICOLOGÍA DEL DESARROLLO II: APRENDIZAJE DE SERVICIO',
          courseId: '018552',
          code: '100000P23S',
          credits: '4.00',
          type: 'O',
          hours: '5.00',
          prerequisites: [
            {
              code: '100000PS27',
              name: 'PSICOLOGÍA DEL DESARROLLO I: APRENDIZAJE DE SERVICIO'
            }
          ]
        },
        {
          status: 'APROBADO',
          term: '03',
          name: 'PSICOLOGÍA EXPERIMENTAL',
          courseId: '018554',
          code: '100000P24S',
          credits: '4.00',
          type: 'O',
          hours: '4.00',
          prerequisites: [
            {
              code: '100000P13S',
              name: 'OBSERVACIÓN Y ENTREVISTA'
            },
            {
              code: '100000VU04',
              name: 'INTRODUCCIÓN A LA VIDA UNIVERSITARIA (IVU)'
            }
          ]
        },
        {
          status: 'APROBADO',
          term: '03',
          name: 'PROBLEMAS Y DESAFÍOS EN EL PERÚ ACTUAL',
          courseId: '018694',
          code: '100000A17E',
          credits: '3.00',
          type: 'O',
          hours: '3.00',
          prerequisites: [
            {
              code: '100000N09I',
              name: 'INDIVIDUO Y MEDIO AMBIENTE'
            },
            {
              code: '100000AL01',
              name: 'COMPRENSIÓN Y REDACCIÓN DE TEXTOS I'
            }
          ]
        },
        {
          status: 'APROBADO',
          term: '04',
          name: 'CIUDADANÍA Y REFLEXIÓN ÉTICA',
          courseId: '021088',
          code: '100000N07C',
          credits: '3.00',
          type: 'O',
          hours: '3.00',
          prerequisites: [
            {
              code: '100000AL01',
              name: 'COMPRENSIÓN Y REDACCIÓN DE TEXTOS I'
            },
            {
              code: '100000N09I',
              name: 'INDIVIDUO Y MEDIO AMBIENTE'
            }
          ]
        },
        {
          status: 'APROBADO',
          term: '04',
          name: 'ESTADÍSTICA DESCRIPTIVA PARA PSICOLOGÍA',
          courseId: '008894',
          code: '100000PS35',
          credits: '4.00',
          type: 'O',
          hours: '4.00',
          prerequisites: [
            {
              code: '100000P11S',
              name: 'TECNOLOGÍAS DEL APRENDIZAJE'
            },
            {
              code: '100000X105',
              name: 'NIVELACIÓN DE MATEMÁTICA-HUMANIDADES'
            }
          ]
        },
        {
          status: 'APROBADO',
          term: '04',
          name: 'INGLÉS IV',
          courseId: '013799',
          code: '100000N10I',
          credits: '3.00',
          type: 'O',
          hours: '3.00',
          prerequisites: [
            {
              code: '100000N08I',
              name: 'INGLÉS III'
            }
          ]
        },
        {
          status: 'APROBADO',
          term: '04',
          name: 'MOTIVACIÓN Y EMOCIÓN',
          courseId: '018557',
          code: '100000P33S',
          credits: '3.00',
          type: 'O',
          hours: '3.00',
          prerequisites: [
            {
              code: '100000PS30',
              name: 'PERSONALIDAD'
            }
          ]
        },
        {
          status: 'APROBADO',
          term: '04',
          name: 'PSICOLOGÍA SOCIAL - COMUNITARIA',
          courseId: '018558',
          code: '100000P34S',
          credits: '4.00',
          type: 'O',
          hours: '5.00',
          prerequisites: [
            {
              code: '100000PS30',
              name: 'PERSONALIDAD'
            },
            {
              code: '100000P23S',
              name: 'PSICOLOGÍA DEL DESARROLLO II: APRENDIZAJE DE SERVICIO'
            }
          ]
        },
        {
          status: 'APROBADO',
          term: '04',
          name: 'PSICOPATOLOGÍA',
          courseId: '018450',
          code: '100000P31S',
          credits: '4.00',
          type: 'O',
          hours: '5.00',
          prerequisites: [
            {
              code: '100000PS30',
              name: 'PERSONALIDAD'
            },
            {
              code: '100000P23S',
              name: 'PSICOLOGÍA DEL DESARROLLO II: APRENDIZAJE DE SERVICIO'
            }
          ]
        },
        {
          status: 'APROBADO',
          term: '04',
          name: 'PSICOPATOLOGÍA',
          courseId: '018757',
          code: '100000P31V',
          credits: '4.00',
          type: 'O',
          hours: '5.00',
          prerequisites: [
            {
              code: '100000PS30',
              name: 'PERSONALIDAD'
            },
            {
              code: '100000P23S',
              name: 'PSICOLOGÍA DEL DESARROLLO II: APRENDIZAJE DE SERVICIO'
            }
          ]
        },
        {
          status: 'EN CURSO',
          term: '05',
          name: 'CURSO INTEGRADOR I: PORTAFOLIO I',
          courseId: '008907',
          code: '100000PS38',
          credits: '4.00',
          type: 'O',
          hours: '5.00',
          prerequisites: [
            {
              code: '100000P31S',
              name: 'PSICOPATOLOGÍA'
            },
            {
              code: '100000P34S',
              name: 'PSICOLOGÍA SOCIAL - COMUNITARIA'
            }
          ]
        },
        {
          status: 'EN CURSO',
          term: '05',
          name: 'ESTADÍSTICA INFERENCIAL PARA PSICOLOGÍA',
          courseId: '018561',
          code: '100000P42S',
          credits: '4.00',
          type: 'O',
          hours: '4.00',
          prerequisites: [
            {
              code: '100000PS35',
              name: 'ESTADÍSTICA DESCRIPTIVA PARA PSICOLOGÍA'
            }
          ]
        },
        {
          status: 'EN CURSO',
          term: '05',
          name: 'INVESTIGACIÓN ACADÉMICA',
          courseId: '021089',
          code: '100000N02C',
          credits: '4.00',
          type: 'O',
          hours: '4.00',
          prerequisites: [
            {
              code: '100000AL01',
              name: 'COMPRENSIÓN Y REDACCIÓN DE TEXTOS I'
            },
            {
              code: '100000N09I',
              name: 'INDIVIDUO Y MEDIO AMBIENTE'
            }
          ]
        },
        {
          status: 'EN CURSO',
          term: '05',
          name: 'PRUEBAS PSICOLÓGICAS I',
          courseId: '018563',
          code: '100000P43S',
          credits: '4.00',
          type: 'O',
          hours: '4.00',
          prerequisites: [
            {
              code: '100000P23S',
              name: 'PSICOLOGÍA DEL DESARROLLO II: APRENDIZAJE DE SERVICIO'
            },
            {
              code: '100000PS30',
              name: 'PERSONALIDAD'
            }
          ]
        },
        {
          status: 'EN CURSO',
          term: '05',
          name: 'PSICOLOGÍA DE LAS ORGANIZACIONES',
          courseId: '008903',
          code: '100000PS37',
          credits: '4.00',
          type: 'O',
          hours: '4.00',
          prerequisites: [
            {
              code: '100000P33S',
              name: 'MOTIVACIÓN Y EMOCIÓN'
            },
            {
              code: '100000P34S',
              name: 'PSICOLOGÍA SOCIAL - COMUNITARIA'
            }
          ]
        },
        {
          status: 'PENDIENTE',
          term: '05',
          name: 'CONSTRUCCIÓN DE PRUEBAS PSICOLÓGICAS',
          courseId: '018860',
          code: '100000E55Y',
          credits: '3.00',
          type: 'E',
          hours: '3.00',
          prerequisites: [
            {
              code: '100000PS35',
              name: 'ESTADÍSTICA DESCRIPTIVA PARA PSICOLOGÍA'
            }
          ]
        },
        {
          status: 'EN CURSO',
          term: '05',
          name: 'PSICOLOGÍA DE LA SEXUALIDAD',
          courseId: '018872',
          code: '100000E67Y',
          credits: '3.00',
          type: 'E',
          hours: '3.00',
          prerequisites: [
            {
              code: '100000P34S',
              name: 'PSICOLOGÍA SOCIAL - COMUNITARIA'
            },
            {
              code: '100000P23S',
              name: 'PSICOLOGÍA DEL DESARROLLO II: APRENDIZAJE DE SERVICIO'
            }
          ]
        },
        {
          status: 'EN CURSO',
          term: '05',
          name: 'PSICOLOGÍA DE LA SEXUALIDAD',
          courseId: '018863',
          code: '100000E58Y',
          credits: '3.00',
          type: 'E',
          hours: '3.00',
          prerequisites: [
            {
              code: '100000P34S',
              name: 'PSICOLOGÍA SOCIAL - COMUNITARIA'
            },
            {
              code: '100000P23S',
              name: 'PSICOLOGÍA DEL DESARROLLO II: APRENDIZAJE DE SERVICIO'
            }
          ]
        },
        {
          status: 'PENDIENTE',
          term: '05',
          name: 'ELEMENTARY BUSINESS ENGLISH',
          courseId: '020259',
          code: '100000A68N',
          credits: '3.00',
          type: 'E',
          hours: '3.00',
          prerequisites: [
            {
              code: '100000N10I',
              name: 'INGLÉS IV'
            }
          ]
        },
        {
          status: 'PENDIENTE',
          term: '06',
          name: 'CREATIVIDAD E INNOVACIÓN',
          courseId: '018565',
          code: '100000P52S',
          credits: '3.00',
          type: 'O',
          hours: '4.00',
          prerequisites: [
            {
              code: '100000P33S',
              name: 'MOTIVACIÓN Y EMOCIÓN'
            }
          ]
        },
        {
          status: 'PENDIENTE',
          term: '06',
          name: 'DIAGNOSTICO DIFERENCIAL',
          courseId: '018566',
          code: '100000P53S',
          credits: '4.00',
          type: 'O',
          hours: '5.00',
          prerequisites: [
            {
              code: '100000P31S',
              name: 'PSICOPATOLOGÍA'
            }
          ]
        },
        {
          status: 'PENDIENTE',
          term: '06',
          name: 'DIAGNOSTICO VOCACIONAL Y EDUCACIONAL',
          courseId: '020997',
          code: '100000PS69',
          credits: '3.00',
          type: 'O',
          hours: '3.00',
          prerequisites: [
            {
              code: '100000P43S',
              name: 'PRUEBAS PSICOLÓGICAS I'
            }
          ]
        },
        {
          status: 'PENDIENTE',
          term: '06',
          name: 'GESTIÓN HUMANA EN LAS ORGANIZACIONES',
          courseId: '018451',
          code: '100000P51S',
          credits: '4.00',
          type: 'O',
          hours: '4.00',
          prerequisites: [
            {
              code: '100000P43S',
              name: 'PRUEBAS PSICOLÓGICAS I'
            },
            {
              code: '100000PS37',
              name: 'PSICOLOGÍA DE LAS ORGANIZACIONES'
            }
          ]
        },
        {
          status: 'PENDIENTE',
          term: '06',
          name: 'PRUEBAS PSICOLÓGICAS II',
          courseId: '018570',
          code: '100000P55S',
          credits: '4.00',
          type: 'O',
          hours: '4.00',
          prerequisites: [
            {
              code: '100000P43S',
              name: 'PRUEBAS PSICOLÓGICAS I'
            }
          ]
        },
        {
          status: 'PENDIENTE',
          term: '06',
          name: 'PSICOLOGÍA EDUCATIVA',
          courseId: '020996',
          code: '100000PS68',
          credits: '3.00',
          type: 'O',
          hours: '3.00',
          prerequisites: [
            {
              code: '100000PS38',
              name: 'CURSO INTEGRADOR I: PORTAFOLIO I'
            }
          ]
        },
        {
          status: 'PENDIENTE',
          term: '06',
          name: 'GESTIÓN HUMANA EN LAS ORGANIZACIONES',
          courseId: '018758',
          code: '100000P51V',
          credits: '4.00',
          type: 'O',
          hours: '4.00',
          prerequisites: [
            {
              code: '100000P43S',
              name: 'PRUEBAS PSICOLÓGICAS I'
            },
            {
              code: '100000PS37',
              name: 'PSICOLOGÍA DE LAS ORGANIZACIONES'
            }
          ]
        },
        {
          status: 'PENDIENTE',
          term: '06',
          name: 'CREATIVIDAD E INNOVACIÓN',
          courseId: '019845',
          code: '100000TV71',
          credits: '3.00',
          type: 'O',
          hours: '4.00',
          prerequisites: [
            {
              code: '100000P33S',
              name: 'MOTIVACIÓN Y EMOCIÓN'
            }
          ]
        },
        {
          status: 'PENDIENTE',
          term: '07',
          name: 'DIAGNOSTICO ORGANIZACIONAL',
          courseId: '018571',
          code: '100000P62S',
          credits: '3.00',
          type: 'O',
          hours: '4.00',
          prerequisites: [
            {
              code: '100000P51S',
              name: 'GESTIÓN HUMANA EN LAS ORGANIZACIONES'
            },
            {
              code: '100000P55S',
              name: 'PRUEBAS PSICOLÓGICAS II'
            },
            {
              code: '100000PS37',
              name: 'PSICOLOGÍA DE LAS ORGANIZACIONES'
            }
          ]
        },
        {
          status: 'PENDIENTE',
          term: '07',
          name: 'DIFICULTADES DEL APRENDIZAJE',
          courseId: '018196',
          code: '100000PE06',
          credits: '4.00',
          type: 'O',
          hours: '4.00',
          prerequisites: [
            {
              code: '100000PS68',
              name: 'PSICOLOGÍA EDUCATIVA'
            }
          ]
        },
        {
          status: 'PENDIENTE',
          term: '07',
          name: 'DINÁMICA DE GRUPOS',
          courseId: '018574',
          code: '100000P64S',
          credits: '3.00',
          type: 'O',
          hours: '3.00',
          prerequisites: [
            {
              code: '100000P34S',
              name: 'PSICOLOGÍA SOCIAL - COMUNITARIA'
            }
          ]
        },
        {
          status: 'PENDIENTE',
          term: '07',
          name: 'PSICOLOGÍA CULTURAL',
          courseId: '018452',
          code: '100000P61S',
          credits: '3.00',
          type: 'O',
          hours: '3.00',
          prerequisites: [
            {
              code: '100000P34S',
              name: 'PSICOLOGÍA SOCIAL - COMUNITARIA'
            }
          ]
        },
        {
          status: 'PENDIENTE',
          term: '07',
          name: 'TÉCNICAS PSICOTERAPÉUTICAS',
          courseId: '008972',
          code: '100000PS58',
          credits: '3.00',
          type: 'O',
          hours: '3.00',
          prerequisites: [
            {
              code: '100000P53S',
              name: 'DIAGNOSTICO DIFERENCIAL'
            }
          ]
        },
        {
          status: 'PENDIENTE',
          term: '07',
          name: 'PSICOLOGÍA CULTURAL',
          courseId: '018759',
          code: '100000P61V',
          credits: '3.00',
          type: 'O',
          hours: '3.00',
          prerequisites: [
            {
              code: '100000P34S',
              name: 'PSICOLOGÍA SOCIAL - COMUNITARIA'
            }
          ]
        },
        {
          status: 'PENDIENTE',
          term: '07',
          name: 'DIAGNOSTICO ORGANIZACIONAL',
          courseId: '019851',
          code: '100000TV77',
          credits: '3.00',
          type: 'O',
          hours: '4.00',
          prerequisites: [
            {
              code: '100000P51S',
              name: 'GESTIÓN HUMANA EN LAS ORGANIZACIONES'
            },
            {
              code: '100000P55S',
              name: 'PRUEBAS PSICOLÓGICAS II'
            },
            {
              code: '100000PS37',
              name: 'PSICOLOGÍA DE LAS ORGANIZACIONES'
            }
          ]
        },
        {
          status: 'PENDIENTE',
          term: '07',
          name: 'METODOLOGÍA, DISEÑO Y ESTRATEGIAS EN EL PROCESO ENSEÑANZA-APRENDIZAJE',
          courseId: '018867',
          code: '100000E62Y',
          credits: '3.00',
          type: 'E',
          hours: '3.00',
          prerequisites: [
            {
              code: '100000PS68',
              name: 'PSICOLOGÍA EDUCATIVA'
            }
          ]
        },
        {
          status: 'PENDIENTE',
          term: '07',
          name: 'PSICOLOGÍA FORENSE',
          courseId: '018862',
          code: '100000E57Y',
          credits: '3.00',
          type: 'E',
          hours: '3.00',
          prerequisites: [
            {
              code: '100000P31V',
              name: 'PSICOPATOLOGÍA'
            }
          ]
        },
        {
          status: 'PENDIENTE',
          term: '08',
          name: 'CAMBIO Y TRANSFORMACIÓN ORGANIZACIONAL',
          courseId: '018453',
          code: '100000P71S',
          credits: '4.00',
          type: 'O',
          hours: '5.00',
          prerequisites: [
            {
              code: '100000P62S',
              name: 'DIAGNOSTICO ORGANIZACIONAL'
            }
          ]
        },
        {
          status: 'PENDIENTE',
          term: '08',
          name: 'CURSO INTEGRADOR II: PORTAFOLIO II',
          courseId: '008971',
          code: '100000PS57',
          credits: '4.00',
          type: 'O',
          hours: '5.00',
          prerequisites: [
            {
              code: '100000PS58',
              name: 'TÉCNICAS PSICOTERAPÉUTICAS'
            },
            {
              code: '100000PE06',
              name: 'DIFICULTADES DEL APRENDIZAJE'
            },
            {
              code: '100000P64S',
              name: 'DINÁMICA DE GRUPOS'
            },
            {
              code: '100000P62S',
              name: 'DIAGNOSTICO ORGANIZACIONAL'
            },
            {
              code: '100000PS38',
              name: 'CURSO INTEGRADOR I: PORTAFOLIO I'
            }
          ]
        },
        {
          status: 'PENDIENTE',
          term: '08',
          name: 'ÉTICA EN PSICOLOGÍA',
          courseId: '008954',
          code: '100000PS52',
          credits: '2.00',
          type: 'O',
          hours: '2.00',
          prerequisites: [
            {
              code: '100000P53S',
              name: 'DIAGNOSTICO DIFERENCIAL'
            },
            {
              code: '100000N07C',
              name: 'CIUDADANÍA Y REFLEXIÓN ÉTICA'
            }
          ]
        },
        {
          status: 'PENDIENTE',
          term: '08',
          name: 'FORMACIÓN PARA LA INVESTIGACIÓN EN PSICOLOGÍA',
          courseId: '018591',
          code: '100000P74S',
          credits: '4.00',
          type: 'O',
          hours: '4.00',
          prerequisites: [
            {
              code: '100000P62S',
              name: 'DIAGNOSTICO ORGANIZACIONAL'
            },
            {
              code: '100000P42S',
              name: 'ESTADÍSTICA INFERENCIAL PARA PSICOLOGÍA'
            },
            {
              code: '100000N02C',
              name: 'INVESTIGACIÓN ACADÉMICA'
            },
            {
              code: '100000N03I',
              name: 'INGLÉS I'
            }
          ]
        },
        {
          status: 'PENDIENTE',
          term: '08',
          name: 'INTERVENCIÓN PSICOEDUCATIVA',
          courseId: '018454',
          code: '100000P72S',
          credits: '4.00',
          type: 'O',
          hours: '4.00',
          prerequisites: [
            {
              code: '100000PE06',
              name: 'DIFICULTADES DEL APRENDIZAJE'
            }
          ]
        },
        {
          status: 'PENDIENTE',
          term: '08',
          name: 'TALLER DE REHABILITACIÓN SOCIAL',
          courseId: '018592',
          code: '100000P75S',
          credits: '3.00',
          type: 'O',
          hours: '4.00',
          prerequisites: [
            {
              code: '100000P53S',
              name: 'DIAGNOSTICO DIFERENCIAL'
            },
            {
              code: '100000P34S',
              name: 'PSICOLOGÍA SOCIAL - COMUNITARIA'
            }
          ]
        },
        {
          status: 'PENDIENTE',
          term: '08',
          name: 'CAMBIO Y TRANSFORMACIÓN ORGANIZACIONAL',
          courseId: '018760',
          code: '100000P71V',
          credits: '4.00',
          type: 'O',
          hours: '5.00',
          prerequisites: [
            {
              code: '100000P62S',
              name: 'DIAGNOSTICO ORGANIZACIONAL'
            }
          ]
        },
        {
          status: 'PENDIENTE',
          term: '08',
          name: 'INTERVENCIÓN PSICOEDUCATIVA',
          courseId: '018761',
          code: '100000P72V',
          credits: '4.00',
          type: 'O',
          hours: '4.00',
          prerequisites: [
            {
              code: '100000PE06',
              name: 'DIFICULTADES DEL APRENDIZAJE'
            }
          ]
        },
        {
          status: 'PENDIENTE',
          term: '09',
          name: 'CONSULTORÍA EN ORGANIZACIONES',
          courseId: '018593',
          code: '100000P82S',
          credits: '3.00',
          type: 'O',
          hours: '3.00',
          prerequisites: [
            {
              code: '100000P71S',
              name: 'CAMBIO Y TRANSFORMACIÓN ORGANIZACIONAL'
            }
          ]
        },
        {
          status: 'PENDIENTE',
          term: '09',
          name: 'INTERNADO I',
          courseId: '008974',
          code: '100000PS60',
          credits: '13.00',
          type: 'O',
          hours: '25.00',
          prerequisites: [
            {
              code: '100000P74S',
              name: 'FORMACIÓN PARA LA INVESTIGACIÓN EN PSICOLOGÍA'
            },
            {
              code: '100000P72S',
              name: 'INTERVENCIÓN PSICOEDUCATIVA'
            },
            {
              code: '100000PS52',
              name: 'ÉTICA EN PSICOLOGÍA'
            },
            {
              code: '100000P71S',
              name: 'CAMBIO Y TRANSFORMACIÓN ORGANIZACIONAL'
            },
            {
              code: '100000P75S',
              name: 'TALLER DE REHABILITACIÓN SOCIAL'
            },
            {
              code: '100000PS58',
              name: 'TÉCNICAS PSICOTERAPÉUTICAS'
            },
            {
              code: '100000PS57',
              name: 'CURSO INTEGRADOR II: PORTAFOLIO II'
            }
          ]
        },
        {
          status: 'PENDIENTE',
          term: '09',
          name: 'INVESTIGACIÓN APLICADA A LA PSICOLOGÍA',
          courseId: '008976',
          code: '100000PS61',
          credits: '2.00',
          type: 'O',
          hours: '2.00',
          prerequisites: [
            {
              code: '100000P74S',
              name: 'FORMACIÓN PARA LA INVESTIGACIÓN EN PSICOLOGÍA'
            }
          ]
        },
        {
          status: 'PENDIENTE',
          term: '09',
          name: 'CONSULTORÍA EN ORGANIZACIONES',
          courseId: '019852',
          code: '100000TV78',
          credits: '3.00',
          type: 'O',
          hours: '3.00',
          prerequisites: [
            {
              code: '100000P71S',
              name: 'CAMBIO Y TRANSFORMACIÓN ORGANIZACIONAL'
            }
          ]
        },
        {
          status: 'PENDIENTE',
          term: '10',
          name: 'FORMACIÓN PARA LA EMPLEABILIDAD',
          courseId: '013798',
          code: '100000N11I',
          credits: '3.00',
          type: 'O',
          hours: '3.00',
          prerequisites: [
            {
              code: '100000P51S',
              name: 'GESTIÓN HUMANA EN LAS ORGANIZACIONES'
            }
          ]
        },
        {
          status: 'PENDIENTE',
          term: '10',
          name: 'INTERNADO II',
          courseId: '008978',
          code: '100000PS62',
          credits: '13.00',
          type: 'O',
          hours: '25.00',
          prerequisites: [
            {
              code: '100000PS60',
              name: 'INTERNADO I'
            }
          ]
        },
        {
          status: 'PENDIENTE',
          term: '10',
          name: 'TALLER DE INVESTIGACIÓN - PSICOLOGÍA',
          courseId: '008979',
          code: '100000PS63',
          credits: '2.00',
          type: 'O',
          hours: '3.00',
          prerequisites: [
            {
              code: '100000PS61',
              name: 'INVESTIGACIÓN APLICADA A LA PSICOLOGÍA'
            }
          ]
        }
      ]
    };
  }

  getPlanProgressEquivalences() {
    return [
      { code: 'C00001', name: 'Matemática básica I' },
      {
        code: 'C00002',
        name: 'Introducción a la matemática para ingeniería'
      },
      { code: 'C00003', name: 'Introducción a la matemática' }
    ];
  }

  getPlanProgressResume() {
    return {
      isProcessing: false,
      requiredCourses: {
        approved: 27,
        pending: 35,
        total: 62
      },
      credits: {
        required: {
          approved: 91,
          pending: 138,
          total: 229
        },
        optional: {
          approved: 1,
          pending: 5,
          total: 6
        },
        total: 235
      }
    };
  }

  getPlanProgressPS() {
    return {
      academicPlanProgressPS: true
    };
  }
}
